export default {
  GET_STATE_LIST_REQUEST: "GET_STATE_LIST_REQUEST",
  GET_STATE_LIST_RESPONSE: "GET_STATE_LIST_RESPONSE",
};
